/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  McpExportAuthHeader,
  McpExportAuthHeader$inboundSchema,
} from "./mcpexportauthheader.js";

/**
 * Authentication requirements for the MCP server
 */
export type McpExportAuthentication = {
  /**
   * Required authentication headers
   */
  headers: Array<McpExportAuthHeader>;
  /**
   * Whether authentication is required
   */
  required: boolean;
};

/** @internal */
export const McpExportAuthentication$inboundSchema: z.ZodMiniType<
  McpExportAuthentication,
  unknown
> = z.object({
  headers: z.array(McpExportAuthHeader$inboundSchema),
  required: z.boolean(),
});

export function mcpExportAuthenticationFromJSON(
  jsonString: string,
): SafeParseResult<McpExportAuthentication, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpExportAuthentication$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpExportAuthentication' from JSON`,
  );
}
